
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { isGoogleMapsConfigured, loadGoogleMaps } from './mapsLoader';

if (isGoogleMapsConfigured()) {
  loadGoogleMaps().catch((error) => {
    console.warn('Google Maps did not load:', error);
  });
}

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Failed to find the root element. Ensure index.html has <div id='root'></div>");
}
